import createClient, { type Middleware } from "openapi-fetch";
import { CSRF_HEADER, csrfToken, needsCsrf } from "@/api/csrf";
import type { paths } from "./schema";

/** Django session auth: send the CSRF token on every state-changing request. */
const csrf: Middleware = {
  onRequest({ request }) {
    if (needsCsrf(request.method)) {
      const token = csrfToken();
      if (token) request.headers.set(CSRF_HEADER, token);
    }
    return request;
  },
};

export const api = createClient<paths>({ baseUrl: "/", credentials: "same-origin" });
api.use(csrf);
